/// <reference path="../../../app.definition.ts" />

import angular from "angular";
export class FormerTeamAlertController {

    static $inject = ["$scope",
        "$state",
        "$http",
        "$filter",
        "CacheService",
        "$uibModalInstance",
        "FormerSubjects",
        "formerTeamNotification",
        "ApiAdapterService"
    ];

    constructor($scope,
        $state,
        $http,
        $filter,
        CacheService,
        $uibModalInstance,
        FormerSubjects,
        formerTeamNotification,
        ApiAdapterService
    ) {
        var formerTeamAlertVm: any = this;
        formerTeamAlertVm.formerSubjectIds = [];
        formerTeamAlertVm.formerSubjects = [];
        formerTeamAlertVm.formerTeamNotification = formerTeamNotification;

        formerTeamAlertVm.init = () => {
            formerTeamAlertVm.formerSubjects = FormerSubjects.formerSubjects;
        }

        formerTeamAlertVm.closePopup = () => {
            ApiAdapterService.updateUserNotificationAlertFlag(formerTeamAlertVm.formerTeamNotification).then(
                (s) => {
                    $uibModalInstance.dismiss();
                }
            );
        }

        formerTeamAlertVm.init();
    }
}


angular.module('eCareVault.common.popUp')
    .controller('FormerTeamAlertController', FormerTeamAlertController);
